import React from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDateWithLocale, safeFormatDate } from '../shared/utils';
import { getActivityIcon } from '../shared/activityUtils';

const MinimizedDaysViewSimple = ({ days }) => {
  const { t } = useTranslation();
  
  if (!days || days.length === 0) {
    return <div className="text-center text-muted py-4">{t('planDetail.days.noDaysAvailable')}</div>;
  }

  return (
    <div>
      {days.map((day, dayIndex) => (
        <Card
          id={`day-card-${day.id}`}
          key={day.id || dayIndex}
          className="mb-2 shadow-sm minimized-day"
        >
          <Card.Header className="bg-light py-2">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">
                <i className="bi bi-calendar-date me-1"></i>
                {t('planDetail.days.day')} {dayIndex + 1}: {day.date ? formatDateWithLocale(day.date, 'EEE, MMM d') : ''}
              </h6>
              {day.planReady === true && (
                <i
                  className="bi bi-circle-fill text-success ms-2"
                  title={t('planDetail.days.planReady')}
                  aria-label={t('planDetail.days.planReady')}
                  style={{ fontSize: '0.7rem' }}
                ></i>
              )}
            </div>
          </Card.Header>
          <ListGroup variant="flush">
            {day.summaryTitle?.trim() && (
              <ListGroup.Item className="py-2 px-3">
                <div className="fw-semibold small text-muted">{day.summaryTitle.trim()}</div>
              </ListGroup.Item>
            )}
            {day.activities && day.activities.length > 0 ? (
              day.activities.map((activity, activityIndex) => (
                <ListGroup.Item 
                  key={activity.id || activityIndex}
                  className="py-2 px-3"
                >
                  <div className="d-flex align-items-center">
                    {getActivityIcon(activity) === 'route-icon' ? (
                      <span className="route-icon me-2"></span>
                    ) : (
                      <i className={`bi ${getActivityIcon(activity)} me-2`}></i>
                    )}
                    <span className="text-truncate" title={activity.name}>
                      {activity.name}
                    </span>
                    {activity.startDateTime && (
                      <small className="text-muted ms-auto minimized-activity-time">
                        {activity.completed && (
                          <Badge bg="success" className="me-1" style={{ fontSize: '0.6rem' }}>{t('planDetail.days.completed')}</Badge>
                        )}
                        {safeFormatDate(activity.startDateTime, 'time')}
                      </small>
                    )}
                  </div>
                </ListGroup.Item>
              ))
            ) : !day.summaryTitle?.trim() ? (
              <ListGroup.Item className="text-center text-muted py-2">
                {t('planDetail.days.noActivities')}
              </ListGroup.Item>
            ) : null}
          </ListGroup>
        </Card>
      ))}
    </div>
  );
};

export default MinimizedDaysViewSimple;
